module.exports = __webpack_public_path__ + "static/dominikawork6-ad896457f380d4bb8a942debc05a3e83.jpg";